import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Badge from './Badge';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as localStorage from '../../../localStorage/localStorage';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import {getScreenComponentByType} from '../../../helpers/componentHelper';
import {COMPONENT_TOOLTIP_OBJECT, COMPONENT_KPI_DASHBOARD_OBJECT} from  '../../../constants/componentConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';

class BadgeDescription extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            badge: this.props.badge,
            userBadge: this.props.userBadge,
            showAchievedCount: false,
            showAchievedState: false,
            locale: {}
        };
        this.getLocale = this.getLocale.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
    }

    componentDidMount() {
        this.getLocale();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userBadge !== nextProps.userBadge) {
            this.setState({userBadge: Object.assign({}, nextProps.userBadge)});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.badge)
            });
        }
    }

    getLocale() {
        let locale = appHelper.getLocalData(this.state.badge);
        this.setState({locale: Object.assign({}, locale)});
    }

    handleProgression() {

    }

    render() {
        return (

                <div className="kpi-overview-row">
                    <div className="kpi-meter-col">
                        <Badge badge={this.state.badge}
                                     userBadge={this.state.userBadge}
                                     showAchievedCount={this.state.showAchievedCount}
                                     showAchievedState={this.state.showAchievedState}/>
                    </div>
                    <div className="kpi-content-col">
                        {appHelper.isDefined(this.state.locale.long_title) && this.state.locale.long_title !== null && this.state.locale.long_title.length > 0
                            ?
                            <h4><strong>{this.state.locale.long_title}</strong></h4>
                            : null
                        }
                        {appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                            ?
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                            : null
                        }
                    </div>
                </div>

        );
    }
}

BadgeDescription.propTypes = {
    badge: PropTypes.object.isRequired,
    userBadge: PropTypes.object.isRequired,
    showAchieved: PropTypes.bool.isRequired,
    bite_id: PropTypes.number,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

BadgeDescription.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        badgeUserData: appHelper.getArrayObjectByKey(state.userData.bites,"bite_id",ownProps.bite_id).badges
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(BadgeDescription);



/** WEBPACK FOOTER **
 ** ./src/components/objects/badges/BadgeDescription.js
 **/